module.exports = __webpack_public_path__ + "img/FancyBridge.db2e6e77.png";